import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getBillInvioiceService = (params = {}) => {
  return api.get(url.GET_ALL_BILL_INVOICE, params);
};

export const addBillInvioceService = (requestParams = {}) => {
  return api.create(url.POST_BILL_INVOICE, requestParams, false, {}, true);
};

export const editNoteService = (id, queryParams) => {
  return api.put(url.PUT_NOTE(id), {}, queryParams, true);
};

export const deleteBillInvoiceService = (id) => {
  return api.delete(url.DELETE_BILL_INVOICE(id));
};

export const editBillInvoiceService = (id, queryParams) => {
  return api.put(url.PUT_BILL_INVOICE(id), queryParams, {}, false, true);
};

export const getBillIdService = (id) => {
  return api.get(url.GET_BILL_BY_ID(id));
};

export const editInvoiceStatusService = (id, status) => {
  return api.put(url.PUT_BILL_INVOICE_STATUS(id,status));
};

export const getBillInvioicePDFService = (id) => {
  return api.get(
    url.DOWNLOAD_PDF(id),
    {},
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    }
  );
};
